/*
 * � 2020 Microsoft. All rights reserved.
 */

define('gamescreen',['pixi',
		'absolute',
		'absolute/storagemanager',
		'Solitaire/Solitaire',
		'Solitaire/SolitaireGameMode',
		'Arkadium/GameEngine/Core/EngineManagers',
		'Arkadium/GameEngine/Tween/Tween',
		'SolitaireShared/CardLogic/CardOp',
		'util/ThemeManager',
		'Solitaire/ChallengeMode',
		'Solitaire/GameResult',
		'Solitaire/GameState',
		'CardUI/SupplyView',
		'audiosprites',
		'lodash',
		'Managers/AdManager',
		'Managers/TelemetryManager'
	],
	function (PIXI, Absolute, StorageManager, SolitaireGame, SolitaireGameMode, EngineManagers, Tween, CardOp, ThemeManager,
	          ChallengeMode, GameResult, GameState, SupplyView, AudioData, _, AdManager, TelemetryManager) {
		var GameScreen = function (ui, game) {
			this.initGameScreen(ui, game);
		};

		GameScreen.prototype = Object.create(Absolute.Screen.prototype);

		GameScreen.prototype.initGameScreen = function (ui, game) {

			Absolute.Screen.call(this);

			this.ui = ui;
			this.game = game;
/* removed by grunt-string-replace as part of the dist:prod step */
		};

		GameScreen.prototype.loadAudio = function (onComplete) {
			var levelLoader = new Absolute.Loader()
			var themeAudio = 'music_theme_' + ThemeManager.CurrentTheme;
			var loadgroups = ["game", themeAudio];
			switch (this.game.mode) {
				case SolitaireGameMode.Klondike:
					loadgroups.push("klondike");
					break;
				case SolitaireGameMode.Spider:
					loadgroups.push("spider");
					break;
				case SolitaireGameMode.TriPeaks:
					loadgroups.push("tripeaks");
					break;
				case SolitaireGameMode.Pyramid:
					loadgroups.push("pyramid");
					break;
				case SolitaireGameMode.FreeCell:
					loadgroups.push("freecell");
					break;
			}

			var toLoad = [];
			for (var lgi = 0; lgi < loadgroups.length; lgi++) {
				_.forEach(AudioData, function (clipInfo) {
					if (clipInfo.loadgroup == loadgroups[lgi]) {
						if (!Absolute.AudioManager.soundLoaded(clipInfo.id)) {
							clipInfo.lazyload = false;
							toLoad.push(clipInfo);
						}
					}
				});
			}


			if (toLoad.length > 0) {
				levelLoader.loadSound(toLoad, function (percentComplete) {
						this.ui.loadingScreen.updateLoadingProgress(percentComplete * 0.5)
					}.bind(this),
					function () {
						onComplete();
						var endGameAudio = [];
						_.forEach(AudioData, function (clipInfo) {
							if (clipInfo.loadgroup == "endgameanimation") {
								if (!Absolute.AudioManager.soundLoaded(clipInfo.id)) {
									clipInfo.lazyload = false;
									endGameAudio.push(clipInfo);
								}
							}
						});
						// load the end game audio, but don't wait for it
						levelLoader.loadSound(endGameAudio, function () {
						}, function () {
						});
					});
			} else {
				onComplete();
			}

		};

		GameScreen.prototype.loadAtlases = function (onComplete, onError) {
			var levelLoader = new Absolute.Loader(),
				atlases = [
					{name: ThemeManager.CurrentTheme},
					{name: ThemeManager.CurrentTheme + "_bg"}
				];

			levelLoader.loadAtlases(atlases, function (percentComplete) {
					Absolute.Debug.log('loading theme ' + percentComplete);
					this.ui.loadingScreen.updateLoadingProgress(0.5 + (percentComplete * 0.5));
				}.bind(this), function () {
					this.ui.loadingScreen.finishLoadingProgress();
					onComplete()
				}.bind(this),
				function () {
					onError();
				});
		};

		GameScreen.prototype.onShow = function (isPortrait, showAd) {
			if (showAd === undefined) showAd = true;
			this.ui.showLoadingScreen();

			Absolute.Screen.prototype.onShow.call(this);
			this.ui.refreshBackground = true;
			this.ui.particleSystem.cleanUp();

			this.loadAudio(
				function () {
					this.loadAtlases(
						function () {
							this.ui.blockClicks();
							var isChallenge = typeof this.game.solitaire.CurrentChallenge !== 'undefined' && this.game.solitaire.CurrentChallenge !== null;
							var startLevel = function () {
								if (this.checkTutorialSeen) this.checkTutorialSeen();
								// AdManager.gameStarted();
								this.ui.unBlockClicks();
								this.addChild(this.game.solitaire);

								this.game.solitaire.StartGame(this.game.mode, this.game.newDeal, this.game.resetScoring,
									this.game.statLossRedeal, showAd);

								var handleScoreChange = function (score) {
										this.game.gameScreenUI.handleScoreChange(score);
									}.bind(this),
									handleScoreRef = handleScoreChange,
									handleTimeChange = function (time) {
										this.game.gameScreenUI.handleTimeChange(time);
									}.bind(this),
									handleTimeRef = handleTimeChange,
									handleBoardComplete = function (boards) {
										this.game.gameScreenUI.handleBoardCompleteChange(boards);
									}.bind(this),
									handleBoardCompleteRef = handleBoardComplete;

								this.game.solitaire.Authority.CardSupply.OnScoreEvent.remove(handleScoreRef);
								this.game.solitaire.Authority.CardSupply.OnScoreEvent.add(handleScoreRef);
								this.game.solitaire.Authority.CardSupply.OnTimeChangeEvent.remove(handleTimeRef);
								this.game.solitaire.Authority.CardSupply.OnTimeChangeEvent.add(handleTimeRef);
								this.game.solitaire.Authority.CardSupply.OnBoardCompletedEvent.remove(handleBoardCompleteRef);
								this.game.solitaire.Authority.CardSupply.OnBoardCompletedEvent.add(handleBoardCompleteRef);

								this.addChild(this.game.gameScreenUI);
								this.addChild(this.game.menuBar);

								this.game.gameScreenUI.onShow(this.game.solitaire.Authority.CardSupply.Score, this.game.solitaire.Authority.CardSupply.CurrentTime, this.game.solitaire.Authority.BoardsCompleted());
								this.game.menuBar.onShow(false, (!this.game.config.singleGame.enabled));


								setTimeout(function () {
									Absolute.MusicManager.playMusic('music_theme_' + ThemeManager.CurrentTheme);
								}, 400);
							}.bind(this);
							if (showAd) {
								AdManager.tryShowAd(
									startLevel,
									isChallenge,
									false,
									isChallenge && !this.game.solitaire.CurrentChallenge.IsStarClub);
							} else {
								startLevel();
							}
						}.bind(this),
						function () {
							this.game.ui.hideLoadingScreen();
							this.game.gameScreenUI.showNetworkErrorDialog();
						}.bind(this));
				}.bind(this));

		};

		GameScreen.prototype.onHide = function () {

			this.removeChild(this.game.solitaire);

			this.game.gameScreenUI.onHide();

			this.game.boostType = null;

			Tween.RemoveAll();

			Absolute.MusicManager.stopMusic();

			Absolute.Screen.prototype.onHide.call(this);

		};

		GameScreen.prototype.handlePause = function () {

		};

		GameScreen.prototype.handleResume = function () {

		};

		GameScreen.prototype.handleOrientationChange = function (isPortrait) {

			Absolute.Screen.prototype.handleOrientationChange.call(this, isPortrait);

		};

		GameScreen.prototype.handleResize = function (isPortrait) {

			this.game.menuBar.handleResize(isPortrait);

		};

		GameScreen.prototype.handleVisibilityChange = function (hidden) {

			if (!Absolute.MusicManager.isMuted() && !hidden) {
				Absolute.MusicManager.playMusic('music_theme_' + ThemeManager.CurrentTheme);
			}

		};

		GameScreen.prototype.beforeRender = function () {

			var now = Date.now();
			EngineManagers.Time.Update(now - this.lastRenderTime);
			this.lastRenderTime = now;

			if (this.game.solitaire.Authority) {
				this.game.solitaire.Update(EngineManagers.Time);
			}

			Tween.UpdateAll();


			Absolute.Screen.prototype.beforeRender.call();
		};

/* removed by grunt-string-replace as part of the dist:prod step */

		GameScreen.prototype.handleCommand = function (command) {
			this.game.gameScreenUI.handleCommand(command);
		};

		return GameScreen;
	});

